import React from 'react';
import BottomTabNavigationItem, {
  BottomNavigationItemProps,
} from '../BottomTabNavigationItem';

const BottomTabNavItemLearn = (
  props: Omit<BottomNavigationItemProps, 'icon'>,
) => {
  const {title = 'Learn', ...rest} = props;
  return <BottomTabNavigationItem icon="learn" title={title} {...rest} />;
};
export default BottomTabNavItemLearn;
